import { auth, functions } from '..'
import { ApproveOperatorSchema } from '@onepercentio/rarum-types/accounts/requests'

export async function approveContract(
  galleryId: string,
  contractToApprove: string,
  approve: boolean,
  tokenId?: number
) {
  return await functions
    .httpsCallable('accounts-approveOperator')({
      tenantId: process.env.REACT_APP_TENANT_IDENTITY_ID,
      approved: approve,
      galleryId,
      operator: contractToApprove,
      ...(tokenId ? { tokenId: String(tokenId) } : {}),
    })
    .then(({ data: { transactionId } }) => transactionId as OkenIdOrMiningHash)
}

export async function approveAllowance(
  currencySymbol: string,
  galleryId: string,
  operator: string,
  howMuchToApprove: string
) {
  return await functions
    .httpsCallable('accounts-approveOperator')({
      tenantId: process.env.REACT_APP_TENANT_IDENTITY_ID,
      internalContract: currencySymbol,
      operator,
      approved: howMuchToApprove,
      galleryId,
    } as ApproveOperatorSchema)
    .then(({ data: { transactionId } }) => transactionId as OkenIdOrMiningHash)
}

export async function signInWithCustomToken(token: string) {
  const {
    data: { authToken },
  } = await functions.httpsCallable('accounts-signInWithCustomToken')({ token })
  await auth.setPersistence('none')
  await auth.signInWithCustomToken(authToken)
}
